import React, { useState } from 'react';
import { Repeat, MonitorSmartphone, ChevronRight, Laptop, X, UserMinus } from 'lucide-react';
import PcChangeRequestForm from './PcChangeRequestForm';
import ReassignWizard from './ReassignWizard';
import NewWorkstationWizard from './NewWorkstationWizard';
import ExitWizard from './ExitWizard';

const OpCard = ({ icon: Icon, title, desc, onClick, testid }) => (
    <button onClick={onClick} data-testid={testid}
        className="group w-full text-left p-5 rounded-2xl bg-slate-900/80 border border-slate-800 hover:border-indigo-500 hover:bg-slate-900 transition-colors flex items-center gap-4">
        <span className="w-12 h-12 rounded-xl bg-indigo-600/20 border border-indigo-500/40 flex items-center justify-center flex-shrink-0"><Icon className="w-6 h-6 text-indigo-300" /></span>
        <span className="flex-1">
            <span className="block text-base font-semibold text-white">{title}</span>
            <span className="block text-xs text-slate-400 mt-0.5">{desc}</span>
        </span>
        <ChevronRight className="w-5 h-5 text-slate-500 group-hover:text-indigo-300 group-hover:translate-x-0.5 transition-transform" />
    </button>
);

export const OperationsHub = ({ apiBase, logo, prefill, onClose, hidden = [] }) => {
    const show = (k) => !hidden.includes(k);
    const [mode, setMode] = useState(null);
    if (mode === 'riassegnazione') return <ReassignWizard apiBase={apiBase} logo={logo} prefill={prefill} onClose={onClose} onBack={() => setMode(null)} />;
    if (mode === 'nuova') return <NewWorkstationWizard apiBase={apiBase} logo={logo} prefill={prefill} onClose={onClose} onBack={() => setMode(null)} />;
    if (mode === 'uscita') return <ExitWizard apiBase={apiBase} logo={logo} prefill={prefill} onClose={onClose} onBack={() => setMode(null)} />;
    if (mode) return <PcChangeRequestForm apiBase={apiBase} logo={logo} prefill={prefill} onClose={onClose} mode={mode} onBack={() => setMode(null)} />;
    const body = (
        <div className="w-full max-w-xl mx-auto py-12 px-4" data-testid="ops-hub">
            <div className="text-center mb-8">
                <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-indigo-600/20 border border-indigo-500/40 mb-3"><MonitorSmartphone className="w-7 h-7 text-indigo-300" /></div>
                <h1 className="text-2xl font-bold">Gestione Operativa</h1>
                <p className="text-sm text-slate-400 mt-1">Scegli il tipo di richiesta per la postazione</p>
            </div>
            <div className="space-y-3">
                {show('ops_riassegnazione') && <OpCard icon={Repeat} title="Riassegnazione postazione" desc="Un PC esistente passa da un utente a un altro" onClick={() => setMode('riassegnazione')} testid="ops-reassign-btn" />}
                {show('ops_nuova') && <OpCard icon={Laptop} title="Nuova postazione" desc="Preparazione di un nuovo PC con tutto il necessario" onClick={() => setMode('nuova')} testid="ops-new-btn" />}
                {show('ops_uscita') && <OpCard icon={UserMinus} title="Uscita dipendente" desc="Un collega lascia l'azienda: blocco accessi, email, dati e PC" onClick={() => setMode('uscita')} testid="ops-exit-btn" />}
            </div>
            <div className="text-center mt-10 pt-5 border-t border-white/10">
                {logo && <img src={logo} alt="86BIT" className="h-8 mx-auto mb-2 opacity-90" />}
                <p className="text-slate-500 text-[10px]">86BIT srl Unipersonale · P.Iva 04353030168</p>
            </div>
        </div>
    );
    if (onClose) {
        return (
            <div className="fixed inset-0 z-[80] overflow-y-auto bg-gradient-to-br from-slate-950 via-slate-900 to-indigo-950 text-white" data-testid="ops-hub-overlay">
                <button onClick={onClose} title="Chiudi" className="fixed top-3 right-3 z-[81] p-2 rounded-full bg-slate-800/90 hover:bg-slate-700 border border-slate-700" data-testid="ops-hub-close"><X className="w-5 h-5" /></button>
                {body}
            </div>
        );
    }
    return <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-indigo-950 text-white">{body}</div>;
};

export default OperationsHub;
